import { TEXT_CATEGORY } from 'constants/category';
import { PAGE_DEFAULT, ROW_DEFAULT } from 'constants/global';

export const EMPTY_DATA_SEARCH_REFERENCE_TEMPLATE_TEXT = {
    text_search: '',
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
    category:TEXT_CATEGORY
};
